import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';

export default function VideoPlayerFacebook({ url, onReady = () => {}, controls = false }) {
    const [width, setWidth] = useState(0);
    const [height, setHeight] = useState(0);

    function setDimension(elem) {
        setWidth(elem.offsetWidth);
        setHeight(elem.offsetHeight);
    }

    return (
        <div
            ref={node => {
                if (node) {
                    setDimension(node);
                }
            }}
            css={containerStyle}
        >
            <iframe
                src={`https://www.facebook.com/plugins/video.php?width=${width}&height=${height}&href=${url}&show_text=false&controls=${controls}`}
                width={width}
                height={height}
                title={url}
                css={iframeStyle}
                onLoad={onReady}
                scrolling="no"
                frameBorder="0"
                allowFullScreen={true}
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            />
        </div>
    );
}

VideoPlayerFacebook.propTypes = {
    url: PropTypes.string,
    onReady: PropTypes.func,
    controls: PropTypes.bool
};

const containerStyle = css`
    width: 100%;
    height: 100%;
    position: relative;
`;

const iframeStyle = css`
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
`;
